<template>
    <div>
        <panel title="Сменить пароль">
            <legend class="mb-3">Сменить пароль:</legend>
            <div class="row mb-3">

            </div>
            <validation-observer ref="form">
                <form>
                    <fieldset>
                        <validation-provider #default="{ errors }" name="password_old" rules="required|min:6|max:16"
                            vid="password_old">
                            <div class="row mb-3">
                                <label class="form-label col-form-label col-md-3">Старый пароль</label>
                                <div class="col-md-9">
                                    <input type="password" v-model="data.password_old" class="form-control"
                                        placeholder="">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </div>
                        </validation-provider>

                        <validation-provider #default="{ errors }" name="password" rules="required|min:6|max:16"
                            vid="password">
                            <div class="row mb-3">
                                <label class="form-label col-form-label col-md-3">Новый пароль</label>
                                <div class="col-md-9">
                                    <input type="password" v-model="data.password" class="form-control" placeholder="">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </div>
                        </validation-provider>


                        <validation-provider #default="{ errors }" name="password_confirm" rules="required|min:6|max:16"
                            vid="password_confirm">
                            <div class="row mb-3">
                                <label class="form-label col-form-label col-md-3">Повторить пароль</label>
                                <div class="col-md-9">
                                    <input type="password" v-model="data.password_confirm" class="form-control"
                                        placeholder="">
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </div>
                            </div>
                        </validation-provider>
                        <div class="row">
                            <div class="col-md-7 offset-md-3 mt-3">
                                <button :disabled="loading" class="btn btn-primary w-120px   me-3"
                                    @click="updatePassword()">
                                    <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                                    <span v-show="!loading"> Сохранить</span>
                                </button>
                                <button :disabled="loading" class="btn btn-default "
                                    @click="() => { this.data = { password_old: '', password: '', password_confirm: '' } }">
                                    Отмена
                                </button>

                            </div>
                        </div>
                    </fieldset>
                </form>
            </validation-observer>


        </panel>
    </div>
</template>

<script>
import HTTP from "../http";
import { show_error, show_message } from "../message";
import AppOptions from '../config/AppOptions.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate';



export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            appOptions: AppOptions,
            loading: false,
            data: { password_old: '', password: '', password_confirm: '' },
        };
    },

    methods: {

        updatePassword() {
            this.loading = true;
            this.$insProgress.start();
            HTTP()
                .put("/password/0", this.data)
                .then((response) => {
                    console.log(response)
                    show_message(this.$notify, response.data)
                })
                .catch((error) => {
                    show_error(this.$notify, this.$refs.form, error.response.data)
                }).finally(() => {
                    this.loading = false;
                    this.$insProgress.finish();
                });
        },
    },
};
</script>

<style>
.w-120px {
    width: 120px !important;
}
</style>